module.exports = __webpack_public_path__ + "static/media/Bedroom3-2.a607f229.jpg";